import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import operoute from '../assets/images/solutions/operoute.png';
import medicatec from '../assets/images/solutions/medicatec.png';
import cedar from '../assets/images/solutions/cedar.svg';
import gitdone from '../assets/images/solutions/gitdone.svg';

const HowItWorksSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Box
      sx={{
        width: '100vw',
        height: { xs: 'auto', sm: 'auto', md: '738px' },
        minHeight: { xs: '800px', sm: '800px' },
        position: 'relative',
        background: 'black',
        marginLeft: 'calc(-50vw + 50%)',
        marginRight: 'calc(-50vw + 50%)',
        display: 'flex',
        justifyContent: 'center',
        py: { xs: 6, sm: 6, md: 0 },
      }}
    >
      <Box
        sx={{
          width: { xs: '90%', sm: '95%', md: '95%', lg: '1140px' },
          position: 'relative',
          zIndex: 3,
          paddingTop: { xs: '40px', sm: '60px', md: '150px' },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: '40px', sm: '50px', md: '75px' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '15px',
            width: '100%',
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color: 'white',
              fontSize: { xs: '32px', sm: '36px', md: '42px' },
              fontFamily: 'Raleway',
              fontWeight: '600',
              textAlign: 'center',
              width: '100%',
            }}
          >
            Tailored Solutions
          </Typography>
          <Typography
            sx={{
              color: 'white',
              fontSize: { xs: '16px', sm: '18px', md: '20px' },
              fontFamily: 'Raleway',
              fontWeight: '400',
              textAlign: 'center',
              width: { xs: '90%', sm: '80%', md: '100%' },
            }}
          >
            Check out our home grown solutions if you are in the Manufacturing, Medical, DevOps and/or Product Management fields we have something for you!
          </Typography>
        </Box>

        <Box
          sx={{
            alignSelf: 'stretch',
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'center', sm: 'center', md: 'flex-start' },
            gap: { xs: '40px', sm: '40px' },
            overflow: 'hidden',
          }}
        >
          {/* Operoute */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '15px',
            }}
          >
            <Box
              component="a"
              href="https://www.operoute.com"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                width: { xs: '260px', sm: '280px', md: '233px' },
                height: { xs: '135px', sm: '135px' },
                background: '#303030',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.03)',
                },
              }}
            >
              <Box
                component="img"
                src={operoute}
                alt="Operoute"
                sx={{
                  width: '200px',
                  height: '41px',
                  objectFit: 'contain',
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
              <Typography sx={{ 
                width: { xs: '260px', sm: '280px', md: '233px' }, 
                color: 'white', 
                fontSize: '20px', 
                fontFamily: 'Raleway', 
                fontWeight: '700',
                textAlign: { xs: 'center', sm: 'center', md: 'left' }
              }}>
                Operoute
              </Typography>
              <Typography sx={{ 
                width: { xs: '260px', sm: '280px', md: '233px' }, 
                color: 'white', 
                fontSize: '16px', 
                fontFamily: 'Raleway', 
                fontWeight: '400', 
                lineHeight: '25px',
                textAlign: { xs: 'center', sm: 'center', md: 'left' }
              }}>
                Keep track of your Production Orders and Dominate your Product Life Cycle.
              </Typography>
            </Box>
          </Box>

          {/* Medicatec */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '15px',
            }}
          >
            <Box
              component="a"
              href="https://www.medicatec.com"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                width: { xs: '260px', sm: '280px', md: '233px' },
                height: { xs: '135px', sm: '135px' },
                background: '#303030',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.03)',
                },
              }}
            >
              <Box
                component="img"
                src={medicatec}
                alt="Medicatec"
                sx={{
                  width: '350px',
                  height: '203px',
                  objectFit: 'contain',
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
              <Typography sx={{ 
                width: { xs: '260px', sm: '280px', md: '233px' }, 
                color: 'white', 
                fontSize: '20px', 
                fontFamily: 'Raleway', 
                fontWeight: '700',
                textAlign: { xs: 'center', sm: 'center', md: 'left' }
              }}>
                Medicatec
              </Typography>
              <Typography sx={{ 
                width: { xs: '260px', sm: '280px', md: '233px' }, 
                color: 'white', 
                fontSize: '16px', 
                fontFamily: 'Raleway', 
                fontWeight: '400', 
                lineHeight: '25px',
                textAlign: { xs: 'center', sm: 'center', md: 'left' }
              }}>
                Cloud-based WebApp for medical office management
              </Typography>
            </Box>
          </Box>

          {/* Cedar */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '15px',
            }}
          >
            <Box
              component="a"
              href="https://www.cedardeployer.io"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                width: { xs: '260px', sm: '280px', md: '233px' },
                height: { xs: '135px', sm: '135px' },
                background: '#303030',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.03)',
                },
              }}
            >
              <Box
                component="img"
                src={cedar}
                alt="Cedar Deployer"
                sx={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
              <Typography sx={{ 
                width: { xs: '260px', sm: '280px', md: '233px' }, 
                color: 'white', 
                fontSize: '20px', 
                fontFamily: 'Raleway', 
                fontWeight: '700',
                textAlign: { xs: 'center', sm: 'center', md: 'left' }
              }}>
                Cedar Deployer
              </Typography>
              <Typography sx={{ 
                width: { xs: '260px', sm: '280px', md: '233px' }, 
                color: 'white', 
                fontSize: '16px', 
                fontFamily: 'Raleway', 
                fontWeight: '400', 
                lineHeight: '25px',
                textAlign: { xs: 'center', sm: 'center', md: 'left' }
              }}>
                Automating your way to build and deploy cloud applications
              </Typography>
            </Box>
          </Box>

          {/* GitDone */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '15px',
            }}
          >
            <Box
              component="a"
              href="https://www.gitdone.io"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                width: { xs: '260px', sm: '280px', md: '233px' },
                height: { xs: '135px', sm: '135px' },
                background: 'white',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '15px',
                overflow: 'hidden',
                position: 'relative',
                cursor: 'pointer',
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.03)',
                },
              }}
            >
              <Box
                component="img"
                src={gitdone}
                alt="GitDone"
                sx={{
                  width: '80%',
                  height: 'auto',
                  objectFit: 'contain',
                  position: 'absolute',
                  top: '90%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
              <Typography sx={{ 
                width: { xs: '260px', sm: '280px', md: '233px' }, 
                color: 'white', 
                fontSize: '20px', 
                fontFamily: 'Raleway', 
                fontWeight: '700',
                textAlign: { xs: 'center', sm: 'center', md: 'left' }
              }}>
                GitDone
              </Typography>
              <Typography sx={{ 
                width: { xs: '260px', sm: '280px', md: '233px' }, 
                color: 'white', 
                fontSize: '16px', 
                fontFamily: 'Raleway', 
                fontWeight: '400', 
                lineHeight: '25px',
                textAlign: { xs: 'center', sm: 'center', md: 'left' }
              }}>
                Manage your team members progress & produce excellent and clear visuals for your Product Owners
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HowItWorksSection; 